import React from 'react'
import { Col, Container, Row } from "react-bootstrap";
import VisionBanner from "../../../images/Inner Page/MediaInteractionBanner.png";
function MediaBanner() {
  return (
    <>
      <section className="banner-sc download-banner">
        {/* <section className="home-banner-main">
          <Container>
            <Row>
              <Col sm={12}>
                <div className="banner-content">
                  <h1>Media Center</h1>
                </div>
                
              </Col>
            </Row>
          </Container>
        </section> */}

              <section className="banner-slider">
            <div className="home-banner-sc">
              <div className="banner-container">
                <img
                  src={VisionBanner}
                  alt="Communication Hub Banner"
                  className="banner-image"
                />
                
                {/* Text Overlay on Left Side */}
                <div className="banner-text-overlay">
                  <div className="banner-contents">
                    <h1 className="banner-title">Communication Hub</h1>
                  </div>
                </div>
              </div>
            </div>
</section>
      </section>
    
    </>
  )
}

export default MediaBanner